const couponTypes = {
  combine: "Combine",
  invalid: "Invalid",
  CombineAndPositionDrills: "CombineAndPositionDrills",
  subscription: "Subscription",
  positionDrills: "PositionDrills",
};
export default couponTypes;
